export var TRIP_ADVISOR_RATING_IMAGE_URL_PART1 = 'https://static.tacdn.com/img2/ratings/traveler/ss';
export var TRIP_ADVISOR_RATING_IMAGE_URL_PART2 = '.svg';
export var TRIP_ADVISOR_SCHEMA_REVIEW_URL = 'http://schema.org/Review';
export var TRIP_ADVISOR_SCHEMA_ORGANIZATION_URL = 'http://schema.org/Organization';
export var TRIP_ADVISOR_SCHEMA_RATING_URL = 'http://schema.org/Rating';
export var TRIP_ADVISOR_SCHEMA_PERSON_URL = 'http://schema.org/Person';